import React from 'react';
import { comum } from "../../../styles/Themes/light";
import { IProposta } from '../../../utility/IProposta';
import { formatarCep } from '../../../utility/formatadorCep';
import {
  Container,
  TitleSection,
  TitleIcon,
  TitleText,
  Label,
  Value,
} from './styles';
import { ContentSection, SectionColumn } from '../styles';

interface DadosAudienciaCardDemandaProps {
  proposta: IProposta;
  showDivider?: boolean;
}

// Ícone de localização para audiência
const LocationIcon: React.FC<{ color: string }> = ({ color }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill={color}/>
  </svg>
);

export default function DadosAudienciaCardDemanda({ proposta, showDivider = false }: DadosAudienciaCardDemandaProps) {
  // Construir endereço a partir dos campos do IProposta
  const construirEndereco = () => {
    const enderecoParts = [];
    
    if (proposta.rua) enderecoParts.push(proposta.rua);
    if (proposta.numero) enderecoParts.push(proposta.numero);
    if (proposta.bairro) enderecoParts.push(proposta.bairro);
    if (proposta.complemento) enderecoParts.push(proposta.complemento);
    if (proposta.cep) enderecoParts.push(`CEP: ${formatarCep(proposta.cep)}`);
    
    // Se não houver campos de endereço, usar endereço virtual
    if (enderecoParts.length === 0 && proposta.endereco_virtual) {
      return proposta.endereco_virtual;
    }
    
    return enderecoParts.join(' - ');
  };

  const endereco = construirEndereco();

  // Só renderiza se houver dados de endereço
  if (!endereco) {
    return null;
  }

  return (
    <Container>
      <TitleSection>
        <TitleIcon>
          <LocationIcon color={comum.colors.interfaceGray300}/>
        </TitleIcon>
        <TitleText>DADOS DA AUDIÊNCIA</TitleText>
      </TitleSection>
      
      <ContentSection>
        <SectionColumn>
          <Label>ENDEREÇO</Label>
          <Value>{endereco}</Value>
        </SectionColumn>
      </ContentSection>
    </Container>
  );
} 